// extracted by mini-css-extract-plugin
export default {"AssessmentAndInterview":"styles_AssessmentAndInterview__VNlif"};